import { createListenerMiddleware } from "@reduxjs/toolkit";
import { saveClubState, userClubsStateListner, saveMembers, addUserToRequests, removeUserFromRequests } from "../persistence/firestoreModelClub";
import { userClubsAndRequestListListner, addToUsersClubList, addClubToUsersRequests, removeClubFromUsersRequests} from "../persistence/firestoreModelUser";
import { addSuggestedBook, updateSuggestionsListener, saveSuggestionsScore, saveSuggestionsInfo, clearSuggestedBooks } from "../persistence/firestoreModelSuggestions";
import { addMember, addPendingRequestClub, removePendingRequestClub, setCurrentBook, setDeadline, updateBookObject, updateClubState, updateMemberProgress, setActiveClubId, createClub} from "../store/clubSlice";
import { addUserClub, addPendingRequestUser, removePendingRequestUser,signOut,updateUserRequestsList,updateUserClubsList } from "../store/userSlice";
import { addBookSuggestion, vote, setVotingDeadline, updateSuggestionBooks, updateSuggestionInfo } from "../store/suggestionsSlice";
import { addNote, removeNote, updateNotes } from "../store/noteboardSlice";
import { saveNotes, userClubsNoteboardListner } from "../persistence/firestoreModelNoteboard";
import { saveSuggestionsToStorage, saveUserToStorage, clearAllStorage, removeUserRequest } from "../storageUtils";
import { clearSearch } from "../store/searchBookSlice";

/*Helper function to get only the relevant properties in the member object for storing in firebase */
function prepareMembersForSave(clubMembers){ 
    return clubMembers.filter(member =>(member.userId))
        .map(member => ({
            userId: member.userId,
            readingProgress: member.readingProgress ?? 0,
            }))   
}


export const listenerMiddleware = createListenerMiddleware();

// Bootstrapping flag to ensure listeners start after a hard refresh
let userListenersStarted = false;



 
/*
-------------------------------------------- USERS --------------------------------------------
*/


/*on user logIn, start listning on the user club list*/

listenerMiddleware.startListening({
    predicate: (action, currentState, previousState) => 
        currentState.user.currentUser !== previousState.user.currentUser,
    effect(action,listnerApi){
        const currentUserId = listnerApi.getState().user.currentUser;
        userClubsAndRequestListListner(currentUserId, listnerApi.dispatch)
        saveUserToStorage(listnerApi.getState().user)
        userListenersStarted = true;
    }
})

// Ensure listeners start after page refresh even if no state change occurs
listenerMiddleware.startListening({
    predicate: (action, currentState) =>
        !userListenersStarted && !!currentState.user.currentUser && Array.isArray(currentState.user.userClubs),
    effect(action, listnerApi){
        const state = listnerApi.getState();
        const currentUserId = state.user.currentUser;
        const userClubs = state.user.userClubs;
        userClubsAndRequestListListner(currentUserId, listnerApi.dispatch);
        userClubsStateListner(userClubs, listnerApi.dispatch);
        userClubsNoteboardListner(userClubs, listnerApi.dispatch);
        userListenersStarted = true;
        console.log("Bootstrapped club and noteboard listeners after refresh");
    }
});

//on updated user clubs array (logIn, adduserClub, updated from firebase ) starts listning on the users clubs
listenerMiddleware.startListening({  
   
    predicate: (action, currentState, previousState) =>
        currentState.user.userClubs !== previousState.user.userClubs
    ,
    effect(action, listnerApi){
        const userClubs = listnerApi.getState().user.userClubs;

        console.log("enter start listning på userclubState");
        userClubsStateListner(userClubs, listnerApi.dispatch)

        userClubsNoteboardListner(userClubs, listnerApi.dispatch)
        console.log("after noteboards listner");
/*
        userClubsSuggestionsListner(userClubs, listnerApi.dispatch)
        console.log("vi har kört effekt ändrat klubb array")  
*/    }
});

listenerMiddleware.startListening({  
    type: addPendingRequestUser.type,
    effect: async(action,listnerApi)=>{
        const userId = listnerApi.getState().user.currentUser
        const clubId = action.payload.clubId
        addClubToUsersRequests(clubId, userId)
        console.log("vi har kört effekt på action pending request");
    }
})

listenerMiddleware.startListening({
    type: updateUserRequestsList.type,
    effect(action, listnerApi){
        saveUserToStorage(listnerApi.getState().user)
    }
})

// When a club state arrives showing current user as a member, drop that club from pending
listenerMiddleware.startListening({
    type: updateClubState.type,
    effect(action, listenerApi) {
        const state = listenerApi.getState();
        const currentUserId = state.user.currentUser;
        const clubId = action.payload.clubId;
        const members = action.payload.members || [];
        const isMember = members.some(m => String(m?.userId) === String(currentUserId));
        if (!isMember) return;
        const pending = state.user.userRequests || [];
        const normalized = pending.map(req => (typeof req === 'object' ? req : { clubId: String(req) }));
        const filtered = normalized.filter(req => String(req.clubId) !== String(clubId));
        if (filtered.length !== pending.length) {
            listenerApi.dispatch(updateUserRequestsList({ pendingRequests: filtered }));
        }
    }
});

listenerMiddleware.startListening({  
    type: removePendingRequestUser.type,
    effect: async(action,listnerApi)=>{
        const userId = listnerApi.getState().user.currentUser
        const clubId = action.payload.clubId
        removeClubFromUsersRequests(clubId, userId)
        removeUserFromRequests(clubId, userId)
        console.log("vi har kört effekt på action pending request");
        removeUserRequest(clubId)
    }
})

// If user clubs get updated (e.g., accepted to a club), ensure any matching
// pending request is removed immediately from local state
listenerMiddleware.startListening({
    type: updateUserClubsList.type,
    effect(action, listenerApi) {
        const state = listenerApi.getState();
        const newClubs = action.payload?.userClubs || [];
        const pending = state.user.userRequests || [];
        if (!Array.isArray(pending) || pending.length === 0) return;

        const normalized = pending.map(req => (typeof req === 'object' ? req : { clubId: String(req) }));
        const filtered = normalized.filter(req => !newClubs.some(c => String(c) === String(req.clubId)));

        if (filtered.length !== pending.length) {
            listenerApi.dispatch(updateUserRequestsList({ pendingRequests: filtered }));
        }
    }
});


//on user adding a club, save it in firebase
listenerMiddleware.startListening({  
    type: addUserClub.type, 

    effect: async(action,listnerApi)=>{
        const currentUserId = listnerApi.getState().user.currentUser;
        const newUserClub = action.payload.clubId;
        addToUsersClubList(currentUserId, newUserClub)
        console.log("vi har kört effekt på action addUserClub");
        saveUserToStorage(listnerApi.getState().user);
    }
    
})
listenerMiddleware.startListening({
    type: signOut.type,
    effect(action, listnerApi){
        clearAllStorage();
        userListenersStarted = false;
    }
});


/*---CLUBS---*/

/*
-------------------------------------------- CLUBS --------------------------------------------
*/
//if a member is added to a club, save it in firebase 
listenerMiddleware.startListening({ 
    type: addMember.type,
    async effect(action, listnerApi){
        const activeClubId = action.payload.clubId
        const clubMembers = listnerApi.getState().club.clubs[activeClubId].members;
        const addedMemberUserId = action.payload.userId
        
        console.log("clubid och userid", activeClubId, addedMemberUserId )
        //få userid via action
        const firebaseMembers = prepareMembersForSave(clubMembers)

        await addToUsersClubList(addedMemberUserId, activeClubId)
        await removeClubFromUsersRequests(activeClubId, addedMemberUserId)
        await removeUserFromRequests(activeClubId, addedMemberUserId)
        await saveMembers(activeClubId, firebaseMembers);
        
        


    }
});

listenerMiddleware.startListening({
    type: addPendingRequestClub.type,
    effect(action, listnerApi){
        const clubId = action.payload.clubId
        const userId = action.payload.userId
        addUserToRequests(clubId, userId)
    }
})

listenerMiddleware.startListening({
    type: removePendingRequestClub.type, 
    async effect(action, listnerApi){
        const clubId = action.payload.clubId
        const userId = action.payload.userId
        removeUserFromRequests(clubId, userId)
        removeClubFromUsersRequests(clubId, userId)
    }
})


listenerMiddleware.startListening({
    type: updateMemberProgress.type,
    effect(action, listnerApi){
        const activeClubId = listnerApi.getState().club.activeClubId;
        const clubMembers = listnerApi.getState().club.clubs[activeClubId].members;
        //få userid via action

        const firebaseMembers = prepareMembersForSave(clubMembers)
        saveMembers(activeClubId, firebaseMembers);
    }

}),

listenerMiddleware.startListening({
    type: setCurrentBook.type,
    async effect(action, listnerApi){
        const clubId = listnerApi.getState().club.activeClubId;
        const club = listnerApi.getState().club.clubs[clubId];

        const fieldToUpdate = {
            currentBookId: action.payload.bookId,
            currentBook: {
                title: action.payload.title ?? null,
                author: action.payload.author ?? null,
                pages: action.payload.pages ?? null,
                genre: action.payload.genre ?? null,
                bookImg: action.payload.bookImg ?? null,
            },
            members: club.members,
        };


        // Optimistic UI: immediately reset suggestions and end voting period
        listnerApi.dispatch(updateSuggestionBooks({ suggestedBooks: [] }));
        listnerApi.dispatch(setVotingDeadline({ votingDeadline: "", isVotingActive: false }));

        // Save current book ID and reset members' progress in Firestore
        await saveClubState(clubId, fieldToUpdate);
/*
        if (resetMembers.length > 0) {
            await saveMembers(clubId, resetMembers);
        }
*/
        // clear suggestions in Firestore so they don't reappear via listeners
        await clearSuggestedBooks(clubId);
    }
}),

listenerMiddleware.startListening({
    type: setDeadline.type, 
    effect(action, listnerApi){
        const clubId = listnerApi.getState().club.activeClubId;
        const fieldToUpdate = {deadline: action.payload.deadline}
        saveClubState(clubId, fieldToUpdate) 
    }
})

import { saveUserClubsToStorage,clearSuggestionsFromStorage,saveNotesToStorage} from "../storageUtils";

listenerMiddleware.startListening({
  matcher: (action) =>
    [addMember, setCurrentBook, setDeadline, updateBookObject, updateClubState, updateMemberProgress, 
setActiveClubId].some(a => a.match(action)),
  effect: (action, listnerApi) => {
    const state = listnerApi.getState();
    // Spara bara det du behöver

    
    saveUserClubsToStorage(state.club)
    
  }
});/*
listenerMiddleware.startListening({
  predicate: (action, currentState, previousState) =>
    (currentState.club.allClubsReady !== previousState.club.allClubsReady && currentState.club.allClubsReady === true),
    effect(action, listenerApi) {
        saveUserClubsToStorage(listenerApi.getState().club);
    }
});
*/
/*
-------------------------------------------- SUGGESTIONS --------------------------------------------
*/
listenerMiddleware.startListening({
 type: setActiveClubId.type,
  effect(action, listenerApi) {
    const activeClubId = action.payload.newClubId;
    updateSuggestionsListener(activeClubId, listenerApi.dispatch);
        // Reset search slice when switching active club to avoid stale results
        listenerApi.dispatch(clearSearch());
        if(activeClubId === null){
            clearSuggestionsFromStorage();
        }
    console.log("listener för suggestions triggad vid ändrat activeClubId", action );
  }
})

listenerMiddleware.startListening({
    type: addBookSuggestion.type,
    effect(action, listnerApi){
        const suggestedBook = action.payload
        const clubId = listnerApi.getState().club.activeClubId
        addSuggestedBook(clubId, suggestedBook) //lägger till den nya suggested book i firebase 
    }
})

listenerMiddleware.startListening({
    type: vote.type,
    effect(action, listnerApi){
    console.log("listener för vote triggad " + action.payload.userId);
        const suggestedBookId = action.payload.bookId
        const clubId = listnerApi.getState().club.activeClubId
        const score = action.payload.score
        const userId = action.payload.userId
        const totalScore = listnerApi.getState().suggestions.suggestedBooks.find(book => book.bookId === suggestedBookId).totalScore
        saveSuggestionsScore(clubId, suggestedBookId, userId, score, totalScore) //sparar score till firebase om det uppdateras
    }
})
listenerMiddleware.startListening({
    type: setVotingDeadline.type,
    effect(action, listnerApi){
        const clubId = listnerApi.getState().club.activeClubId
        const info = {
            clubId: clubId,
            isVotingActive: listnerApi.getState().suggestions.isVotingActive,
            votingDeadline: action.payload.votingDeadline
        }
        saveSuggestionsInfo(info)
    }
})
listenerMiddleware.startListening({
    matcher: (action) =>
    [addBookSuggestion, vote, setVotingDeadline, updateSuggestionInfo, updateSuggestionBooks].some(a => a.match(action)),
    effect: (action, listnerApi) => {
    const state = listnerApi.getState();
    saveSuggestionsToStorage(state.suggestions);
  }
});
// skapa lisener för att upptecka när en ny klubb skapas och skapa suggestionsDoc i firestore 
listenerMiddleware.startListening({
    actionCreator: createClub.fulfilled,
    effect(action, listnerApi){
        const clubId = action.payload.clubId
        console.log("listener för createClub triggad, clubId:", clubId)
        //skapa suggestionsDoc i firestore
        saveSuggestionsInfo({
            clubId: clubId,
            isVotingActive: false,
            votingDeadline: ""
        })
    }
})

/*NOTEBOARD */

/*
-------------------------------------------- NOTEBOARD --------------------------------------------
*/
listenerMiddleware.startListening({
    type: addNote.type,
    effect(action, listnerApi){
        const clubId = action.payload.clubId
        const clubNotes = listnerApi.getState().noteboard[clubId]
        saveNotes(clubId, clubNotes)
    }

})

listenerMiddleware.startListening({
    type: removeNote.type,
    effect(action, listnerApi){
        const clubId = action.payload.clubId
        const clubNotes = listnerApi.getState().noteboard[clubId]
        saveNotes(clubId, clubNotes)
    }
})
listenerMiddleware.startListening({
  matcher: (action) =>
    [addNote, removeNote, updateNotes].some(a => a.match(action)),
    effect: (action, listnerApi) => {
    const state = listnerApi.getState();
    console.log("listener för noteboard triggad"+ state.noteboard)
    // Spara bara det du behöver
    saveNotesToStorage(state.noteboard);
  }
});